module.exports = __webpack_public_path__ + "img/yjbg1.550eeb6.550eeb6d.png";